import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CloseOutlined } from '@ant-design/icons';
import { GlobalTopBarContext } from '@iso/containers/Dashboard/layoutContext';
import MesaPaneContext from '@iso/containers/Dashboard/mesaPane';
import { setTitleBar, clearTitleBar } from '@iso/containers/Dashboard/titleBarStore';
import './PageTitleBar.css';

/**
 * Título padrão das telas (modelo "| Painel do Colaborador ——— X").
 *
 * Dentro do Dashboard existe uma barra de título GLOBAL fixa no topo
 * (DashboardTitleBar): aqui só registramos título e destino do "X" e não
 * desenhamos nada — assim o topo mostra "| TÍTULO ——— X" no lugar dos atalhos.
 * Fora do Dashboard (board, PDF, PDV, gestão de empresas...), desenha a barra
 * como antes.
 *
 * `backTo`: destino ao clicar no X (padrão: /dashboard). Nas telas de cadastro,
 * passe a rota da LISTAGEM (ex.: "/dashboard/product").
 */
export default function PageTitleBar({ title, backTo, info }) {
	const history = useHistory();
	const hasGlobalBar = useContext(GlobalTopBarContext);
	// Painel secundário (lado a lado) não mexe na barra de título global
	const pane = useContext(MesaPaneContext);

	useEffect(() => {
		// Painel secundário: entrega o título para o cabeçalho da própria
		// janela (lado a lado) e não toca na barra de título global.
		if (pane && pane.mode === 'secondary') {
			if (typeof pane.onTitle === 'function') pane.onTitle(title || null);
			return undefined;
		}

		if (!hasGlobalBar) return undefined;

		setTitleBar({ title, backTo: backTo || null, info: info || null });
		return () => clearTitleBar();
	}, [title, backTo, info, hasGlobalBar, pane]);

	if (hasGlobalBar) return null;

	return (
		<>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					backgroundColor: '#fff',
					padding: '12px 16px',
					borderRadius: '8px 8px 0 0',
					marginBottom: 0,
					width: '100%',
				}}
			>
				<span
					style={{
						width: 5,
						height: 40,
						backgroundColor: '#E4E6E9',
						display: 'inline-block',
						marginRight: 15,
						borderRadius: 2,
						flexShrink: 0,
					}}
				/>
				<h1
					style={{
						fontSize: 16,
						fontWeight: 500,
						color: '#788195',
						margin: '0 15px 0 0',
						whiteSpace: 'nowrap',
						flexShrink: 0,
					}}
				>
					{title}
				</h1>
				<span
					style={{
						flex: 1,
						height: 1,
						backgroundColor: '#E4E6E9',
						minWidth: 20,
						marginRight: 12,
					}}
				/>
				<CloseOutlined
					onClick={() => {
						history.push(backTo || '/dashboard');
					}}
					className="headerIcon"
					style={{ fontSize: 24, marginLeft: 12 }}
					title={backTo ? 'Voltar à listagem' : 'Voltar ao início'}
				/>
			</div>
		</>
	);
}
